import { applyChange } from '../../../utils/loadPositions';

let consecutiveRedDeletes = 0;
let consecutiveOrangeDeletes = 0;
let lastRedDeletePestanya = null;
let lastOrangeDeletePestanya = null;
let resetTimerRed = null;
let resetTimerOrange = null;

const normalizePestanya = (pestanya) => String(pestanya || '').trim().toLowerCase();

const resetRedCounter = () => {
  consecutiveRedDeletes = 0;
  lastRedDeletePestanya = null;
};

const resetOrangeCounter = () => {
  consecutiveOrangeDeletes = 0;
  lastOrangeDeletePestanya = null;
};

const resetRedCounterSoon = () => {
  if (resetTimerRed) clearTimeout(resetTimerRed);
  resetTimerRed = setTimeout(() => {
    resetRedCounter();
  }, 30000); // reset after 30s of inactivity
};

const resetOrangeCounterSoon = () => {
  if (resetTimerOrange) clearTimeout(resetTimerOrange);
  resetTimerOrange = setTimeout(() => {
    resetOrangeCounter();
  }, 30000); // reset after 30s of inactivity
};

const getUserAssistencia = (assistenciesEvent, userId) => {
  if (!assistenciesEvent || userId === undefined || userId === null) return null;
  return assistenciesEvent?.find(a => parseInt(a.id) === parseInt(userId))?.['assistència'];
};

const isUserRed = (assistenciesEvent, userId) => {
  return getUserAssistencia(assistenciesEvent, userId) === 0;
};

const isUserOrange = (assistenciesEvent, userId) => {
  const assist = getUserAssistencia(assistenciesEvent, userId);
  // Orange = not confirmed (not 0, 1, or 2)
  return assist !== 0 && assist !== 1 && assist !== 2;
};

const isUserLateOrEarly = (props, userId) => {
  const arribenTard = props?.arribenTard || [];
  const surtenAviat = props?.surtenAviat || [];
  const parsedUserId = parseInt(userId);
  return arribenTard.some(id => parseInt(id) === parsedUserId)
    || surtenAviat.some(id => parseInt(id) === parsedUserId);
};

const getCaixesMetadata = (props) => props?.withAddons || props?.json || {};

const isCaixaInCurrentPestanya = (props, caixaId) => {
  const currentPestanya = normalizePestanya(props?.pestanya);
  if (!currentPestanya) return true;

  const caixa = getCaixesMetadata(props)?.[caixaId];
  const caixaPestanya = normalizePestanya(caixa?.pestanya);

  return caixaPestanya === currentPestanya || (!caixaPestanya && currentPestanya === 'pinya');
};

const getCurrentPestanyaLocationText = (props) => {
  const currentPestanya = String(props?.pestanya || '').trim();
  return currentPestanya ? ` a la pestanya actual (${currentPestanya})` : '';
};

const getCurrentPestanyaScopeText = (props) => {
  const currentPestanya = String(props?.pestanya || '').trim();
  return currentPestanya ? ` de la pestanya actual (${currentPestanya})` : ' de la pissarra';
};

export const getRedCaixesIds = (posicions, assistenciesEvent, props) => {
  if (!posicions?.caixes) return [];
  return Object.keys(posicions.caixes)
    .filter(caixaId => isCaixaInCurrentPestanya(props, caixaId))
    .filter(caixaId => {
      const userId = posicions?.caixes?.[caixaId];
      return isUserRed(assistenciesEvent, userId) || isUserLateOrEarly(props, userId);
    });
};

export const getOrangeCaixesIds = (posicions, assistenciesEvent, props) => {
  if (!posicions?.caixes) return [];
  return Object.keys(posicions.caixes)
    .filter(caixaId => isCaixaInCurrentPestanya(props, caixaId))
    .filter(caixaId => isUserOrange(assistenciesEvent, posicions?.caixes?.[caixaId]));
};

const bulkDeleteCaixes = (props, caixesIds) => {
  const { socket, setCaixaSelected } = props || {};
  if (caixesIds.length === 0) return;

  const room = `${props.selectedEvent}.${props.selectedBundle}.${props.selectedVersio}`;
  const action_id = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);

  caixesIds.forEach(caixaId => {
    applyChange(props, `${caixaId},_EMPTY_`);
    socket.emit('.save_change_to_room', room, `${caixaId},_EMPTY_`, action_id);
  });
  setCaixaSelected?.(-1);
};

export const deleteAllRed = (props, skipConfirm = false) => {
  const { posicions, assistenciesEvent } = props || {};
  const caixesInRed = getRedCaixesIds(posicions, assistenciesEvent, props);
  if (caixesInRed.length === 0) return;

  if (!skipConfirm) {
    const ok = window.confirm(
      `Segur que vols treure${getCurrentPestanyaScopeText(props)} tots els castellers que no vindran, marxen aviat o arriben tard?`
    );
    if (!ok) return;
  }

  bulkDeleteCaixes(props, caixesInRed);
  resetRedCounter();
};

export const deleteAllOrange = (props, skipConfirm = false) => {
  const { posicions, assistenciesEvent } = props || {};
  const caixesInOrange = getOrangeCaixesIds(posicions, assistenciesEvent, props);
  if (caixesInOrange.length === 0) return;

  if (!skipConfirm) {
    const ok = window.confirm(
      `Segur que vols treure${getCurrentPestanyaScopeText(props)} tots els castellers que no han confirmat?`
    );
    if (!ok) return;
  }

  bulkDeleteCaixes(props, caixesInOrange);
  resetOrangeCounter();
};

export const recordDeleteAndMaybePromptByUserId = (deletedUserId, assistenciesEvent, props) => {
  const currentPestanya = normalizePestanya(props?.pestanya) || '__all__';

  if (!deletedUserId) {
    resetRedCounter();
    resetOrangeCounter();
    return;
  }

  if (isUserRed(assistenciesEvent, deletedUserId)) {
    if (lastRedDeletePestanya !== currentPestanya) {
      consecutiveRedDeletes = 0;
    }

    lastRedDeletePestanya = currentPestanya;
    consecutiveRedDeletes += 1;
    resetOrangeCounter();
    resetRedCounterSoon();

    if (consecutiveRedDeletes >= 3) {
      const confirmBulk = window.confirm(
        `Has eliminat 3 'No vinc' seguits${getCurrentPestanyaLocationText(props)}.\nVols eliminar tots els 'No vinc'${getCurrentPestanyaScopeText(props)}?` +
          "\n\nPels pròxims cops: mantén premut durant 3 segons el botó de borrar sobre un vermell per fer-ho ràpid."
      );
      if (confirmBulk) {
        deleteAllRed(props, true);
      }
      resetRedCounter();
    }
  } else if (isUserOrange(assistenciesEvent, deletedUserId)) {
    if (lastOrangeDeletePestanya !== currentPestanya) {
      consecutiveOrangeDeletes = 0;
    }

    lastOrangeDeletePestanya = currentPestanya;
    consecutiveOrangeDeletes += 1;
    resetRedCounter();
    resetOrangeCounterSoon();

    if (consecutiveOrangeDeletes >= 3) {
      const confirmBulk = window.confirm(
        `Has eliminat 3 'No confirmats' seguits${getCurrentPestanyaLocationText(props)}.\nVols eliminar tots els 'No confirmats'${getCurrentPestanyaScopeText(props)}?` +
          "\n\nPels pròxims cops: mantén premut durant 3 segons el botó de borrar sobre un taronja per fer-ho ràpid."
      );
      if (confirmBulk) {
        deleteAllOrange(props, true);
      }
      resetOrangeCounter();
    }
  } else {
    resetRedCounter();
    resetOrangeCounter();
  }
};

// Keep backwards compatibility
export const recordRedDeleteAndMaybePromptByUserId = recordDeleteAndMaybePromptByUserId;

export const resetDeleteCounters = () => {
  resetRedCounter();
  resetOrangeCounter();
  if (resetTimerRed) clearTimeout(resetTimerRed);
  if (resetTimerOrange) clearTimeout(resetTimerOrange);
  resetTimerRed = null;
  resetTimerOrange = null;
};

// Keep backwards compatibility
export const resetRedDeleteCounter = resetDeleteCounters;

